import { Routes } from '@angular/router';
import { adminGuard, partnerGuard, clientGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },

  {
    path: 'login',
    loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule)
  },

  {
    // Public partner application (sign-up)
    path: 'apply',
    loadChildren: () => import('./features/apply/apply.module').then(m => m.ApplyModule)
  },

  {
    // Public, unauthenticated certified-specialist profiles: /p/:id
    path: 'p',
    loadChildren: () => import('./features/public/public.module').then(m => m.PublicModule)
  },

  {
    path: 'admin',
    canActivate: [adminGuard],
    loadChildren: () => import('./features/admin/admin.module').then(m => m.AdminModule)
  },

  {
    path: 'partner',
    canActivate: [partnerGuard],
    loadChildren: () => import('./features/partner/partner.module').then(m => m.PartnerModule)
  },

  {
    path: 'client',
    canActivate: [clientGuard],
    loadChildren: () => import('./features/client/client.module').then(m => m.ClientModule)
  },

  { path: '**', redirectTo: '/login' }
];
